module.exports = __webpack_public_path__ + "static/media/MyAccountScreen.866fa212.png";